<template>
  <div class="cwc-warning-dialog">
    <el-dialog
      :visible.sync="isVisible"
      :show-close="showClose"
      :show-confirm-button="showConfirmButton"
      :show-cancel-button="showCancelButton"
      :custom-class="`cwc-warning-dialog-custom-class width-${width}`"
    >
      <div slot="title" class="cwc-warning-dialog-header" >
        <CwcIcon name="ico_exclamation_triangle" :width="40" color="#FF2E38" bgColor="#FFF1EF"  padding="12px" />
        <div class="cwc-warning-dialog-header-title">{{ title }}</div>
      </div>
      <div class="cwc-warning-dialog-body">
        <div class="cwc-warning-dialog-body-message" :class="{ 'center': center }">{{ message }}</div>
      </div>
      <div slot="footer" class="cwc-warning-dialog-footer">
        <CwcButton v-if="showCancelButton" :typeWidth="typeWidthButton" :width="widthButton" :name="cancelButtonText" @click="close" />
        <CwcButton v-if="showConfirmButton" :typeWidth="typeWidthButton" :width="widthButton" :name="confirmButtonText" @click="confirm" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CwcIcon from './CwcIcon.vue'
import CwcButton from './CwcButton.vue'

export default {
  components: {
    CwcIcon,
    CwcButton
  },
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    showClose: { type: Boolean, default: false },
    showConfirmButton: { type: Boolean, default: true },
    showCancelButton: { type: Boolean, default: false },
    confirmButtonText: { type: String, default: 'ok' },
    cancelButtonText: { type: String, default: 'cancel' },
    typeWidthButton: { type: String, default: 'hug' },
    width: { type: Number, default: 600 },
    widthButton: { type: Number, default: 100 },
    center: { type: Boolean, default: false }
  },
  data () {
    return {
      isVisible: false
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.isVisible = newVal
      },
      immediate: true
    },
    isVisible: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.isVisible = false
    },
    confirm () {
      this.isVisible = false
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss">
.cwc-warning-dialog {
  .cwc-warning-dialog-custom-class {
    border-radius: 24px;
    max-width: 100vw;

    &.width-400 {
      max-width: 400px;
    }

    &.width-600 {
      max-width: 600px;
    }

    .el-dialog__header {
      font-size: 20px;
      font-weight: bold;
      color: #3E4045;

      .cwc-warning-dialog-header {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 12px;
      }
    }

    .el-dialog__body {
      font-size: 16px;
      font-weight: 400;
      color: #63666E;
      padding: 20px !important;

      .cwc-warning-dialog-body-message {
          &.center {
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .el-dialog__footer {
      border-top: none !important;
      padding: 24px !important;

      .cwc-warning-dialog-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
      }
    }
  }
}
</style>